export const SET_UNREAD_COUNT = "INAPP_SET_UNREAD_COUNT";
export const ADD_INAPP_NOTIFICATION = "INAPP_ADD_NOTIFICATION";
export const MARK_ALL_READ = "INAPP_MARK_ALL_READ";

export const setUnreadCount = (count) => ({
  type: SET_UNREAD_COUNT,
  payload: count,
});

export const addInAppNotification = (notification) => ({
  type: ADD_INAPP_NOTIFICATION,
  payload: notification,
});

export const markAllRead = () => ({
  type: MARK_ALL_READ,
});
